export default __webpack_public_path__ + "static/media/Shadowed Valleys-8.9e38c93d.jpg";